import { useTranslation } from 'react-i18next';

import img1 from '../../assets/images/about-us/1.jpg';
import img2 from '../../assets/images/about-us/2.jpg';
import img3 from '../../assets/images/about-us/3.jpg';

import styles from './styles.module.scss';

const AboutUsPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.aboutUsPage}>
      <h1>{t('aboutUs.header')}</h1>
      <div className={styles.content}>
        <div className={styles.mainText}>{t('aboutUs.txt1')}</div>
        <div className={styles.infoItem}>
          <div className={styles.infoWrapper}>{t('aboutUs.txt2')}</div>
          <div className={styles.imgWrapper}>
            <img src={img1} alt="" />
          </div>
        </div>
        <div className={`${styles.infoItem} ${styles.infoItem2}`}>
          <div className={styles.imgWrapper}>
            <img src={img2} alt="" />
          </div>
          <div className={styles.infoWrapper}>{t('aboutUs.txt3')}</div>
        </div>
        <div className={styles.infoItem}>
          <div className={styles.infoWrapper}>{t('aboutUs.txt4')}</div>
          <div className={styles.imgWrapper}>
            <img src={img3} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPage;
